import React from "react";
import ReactFullpage from "@fullpage/react-fullpage";
import MainSection from './containers/MainSection';
import { anchors } from './domain/menus';
import LanguagesSection from './containers/LanguagesSection';
import WebFrameworksSection from './containers/WebFrameworksSection';
import LanguagesDetailSection from './containers/LanguagesDetailSection';
import WebFrameworksDetailSection from './containers/WebFrameworksDetailSection';
import AwsSection from './containers/AwsSection';
import AwsSectionSecond from './containers/AwsSectionSecond';
import GcpSection from './containers/GcpSection';
import OthersSection from './containers/OthersSection';
import OthersDetailSection from './containers/OthersDetailSection';
import './FullpageWrapper.css';


const FullpageWrapper = () => (
  <ReactFullpage
    licenseKey = {'B2EA767D-E862462A-946ACC98-715E6B75'}
    anchors={anchors}
    navigation
    navigationTooltips={anchors}
    // #111111
    sectionsColor={[
      "#111111",
      "#000066",
      "#000066",
      "#111111",
      "#111111",
      "#000066",
      "#000066",
      "#111111",
      "#000066",
      "#000066",
    ]}
    onLeave={(origin:any, destination:any, direction:any) => {
      // console.log("onLeave event", { origin, destination, direction });
    }}
    render={({ state, fullpageApi }: {state: any, fullpageApi: any}) => {
      // console.log("render prop change", state, fullpageApi);
      return (
        <div>
          <MainSection />
          <LanguagesSection />
          <LanguagesDetailSection />
          <WebFrameworksSection />
          <WebFrameworksDetailSection />
          <AwsSection />
          <AwsSectionSecond />
          <GcpSection />
          <OthersSection />
          <OthersDetailSection />
        </div>
      );
    }}
  />
);

export default FullpageWrapper;
